module.exports = __webpack_public_path__ + "static/media/S3N10-1.8a150d86.svg";